import uniqueId from '@form-create/utils/lib/unique';
var label = '明细';
var name = 'approvalBill';
export default {
  icon: 'iconfont iconmingxi1',
  label: label,
  name: name,
  drag: true,
  inside: false,
  rule: function rule() {
    return {
      type: name,
      field: uniqueId(),
      title: label,
      info: '',
      props: {
        member: false
      },
      children: []
    };
  },
  props: function props() {
    return [];
  },
  basic: function basic() {}
};